<template>
  <div class="online-content">
    <div class="video-home">
      <div class="video-title">
        <div class="video-tab-list">
          <!-- <p class="item cur"></p> -->
          <router-link :to="{path: '/Book/BookList'}" tag="p" class="item">{{$t('blendType.allBook')}}</router-link>
          <router-link :to="{path: '/Book/BookFavorite'}" tag="p" class="item">{{$t('blendType.myloveBook')}}</router-link>
        </div>
        <div class="video-btns">
          <button type="button" @click="emitChangeType" class="switch-btn">
            <em class="item" :class="{'cur': isChinese}">{{$t('blendType.zhong')}}</em>
            <em class="item" :class="{'cur': !isChinese}">{{$t('blendType.ying')}}</em>
          </button>
          <!-- <button type="button" class="love-btn">
            <em></em> 我很喜欢
          </button> -->
          <em @click="bakToPrev" class="back_arrow"></em>
        </div>
      </div>
      <div class="video-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "video-home",
  props: ["title"],
  data() {
    return {
      isChinese: false
    }
  },
  methods: {
    bakToPrev() {
      this.$emit("bakToPrev");
    },
    emitChangeType () {
      this.isChinese = !this.isChinese
      this.$emit('toggleChange', this.isChinese)
    }
  }
};
</script>
<style lang="less">
.video-home {
  height: 100%;
  border-radius: 20px;
  .video-title {
    height: 65px;
    display: flex;
    padding: 0 20px;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #181818;
    border-radius: 10px 10px 0 0;
    background-color: #fff;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.05);
    .back_arrow {
      width: 24px;
      height: 24px;
      background: url("../../assets/images/studyCenter/back-icon.png") center
        center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
  .video-content {
    height: calc(100% - 65px);
    margin-top: 1px;
    background-color: #fff5ef;
    border-radius: 0 0 10px 10px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.05);
  }

  .video-tab-list {
    display: flex;
    align-items: center;
    .item {
      margin-right: 20px;
      font-size: 16px;
      color: rgba(24, 24, 24, 1);
      line-height: 22px;
      cursor: pointer;
      &.cur,
      &.router-link-exact-active {
        color: #ff5c67;
      }
    }
  }

  .video-btns {
    display: flex;
    align-items: center;
    .switch-btn {
      width: 80px;
      height: 40px;
      margin-right: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 20px;
      background-color: #eee;
      .item {
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 15px;
        color: #999;
        border-radius: 50%;
        background-attachment: fixed;
        &.cur {
          background-color: #ff5c67;
          color: #fff;
        }
      }
    }
    .love-btn {
      display: flex;
      align-items: center;
      em {
        width: 16px;
        height: 13px;
        margin-right: 5px;
        background: url("../../assets/images/studyCenter/love-icon.png")
          no-repeat center center;
        background-size: 100% 100%;
      }
      height: 40px;
      padding: 0 25px;
      margin-right: 15px;
      font-size: 14px;
      color: #fff;
      border-radius: 20px;
      cursor: pointer;
      background-color: #ff5c67;
    }
  }
}
</style>